import http from '@/http'

const state = {
  chapters: [],
  body: null
}

const getters = {
  bodyChapters: (state) => {
    return state.chapters
  },
  selectBody: (state) => {
    return state.body
  }
}

const mutations = {
  setChapters (state, data) {
    state.chapters = data.chapters
  },
  setBody (state, data) {
    state.body = data.body
    if (data.body) {
      state.body.chapter_id = data.body.chapter_id === null ? 0 : data.body.chapter_id
    }
  }
}

const actions = {
  fetch ({commit}, payload) {
    return http.post('/body/select/', {'book_id': payload.book_id}).then(function (response) {
      console.log(response.body)
      if (response.result && response.body) {
        commit('setChapters', {'chapters': response.body})
      }
    })
  },
  get ({commit}, payload) {
    return http.post('/body/select/', {'id': payload.id}).then(function (response) {
      if (response.result && response.body) {
        commit('setBody', {'body': response.body})
      }
      return response
    })
  },
  clear ({commit}) {
    commit('setChapters', {'chapters': []})
    commit('setBody', {'body': null})
  },
  insert ({commit}, payload) {
    console.log(payload.body)
    return http.post('/body/insert/', payload.body).then(function (response) {
      return response
    })
  },
  update ({commit}, payload) {
    console.log(payload.body)
    return http.post('/body/update/', payload.body).then(function (response) {
      if (response.result) {
        commit('setBody', {'body': payload.body})
      }
      return response
    })
  },
  updateDetail ({commit}, payload) {
    console.log(payload.body)
    return http.post('/bodydetail/update/', payload.body).then(function (response) {
      if (response.result) {
        commit('setBody', {'body': payload.body})
      }
      return response
    })
  },
  delete ({commit}, payload) {
    console.log(payload.id)
    return http.post('/body/delete/', {'id': payload.id}).then(function (response) {
      return response
    }).catch(function (error) {
      return error
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Bodies.js